import { render, staticRenderFns } from "./FormGeolocation.vue?vue&type=template&id=4020ea3c&"
import script from "./FormGeolocation.vue?vue&type=script&lang=js&"
export * from "./FormGeolocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports